import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Healthcaremilo() {
  return (
    <section className="web_visibility p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center resp_order"
          >
            <StaticImage
              src="../../images/services-usa/healthcare-new/milo_mob.webp"
              alt="milo-mob-casestudy"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={884}
              height={663}
            />
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Why Choose a Healthcare App Development Company for Digital Health
              Solutions?
            </h2>
            <p>
              TekRevol is a recognized healthcare app development company,
              delivering cutting-edge solutions by utilizing AI and IoMT to
              optimize patient care and drive medical advancements. We
              collaborated with healthcare practitioners and companies to
              address global health concerns. Our considerable experience
              working with doctors, patients, pharmacies, delivery systems,
              prescription systems, and EHR procedures enables us to design
              bespoke solutions quickly and accurately.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Healthcaremilo;
